import * as backend from '../backend-helpers/profile';
import {BobTVUser} from '../../local_modules/bobtvuser';

const GET_BUYXXL_PROFILE_REQUEST = 'GET_BUYXXL_PROFILE_REQUEST';
const GET_BUYXXL_PROFILE_SUCCESS = 'GET_BUYXXL_PROFILE_SUCCESS';
const GET_BUYXXL_PROFILE_FAILURE = 'GET_BUYXXL_PROFILE_FAILURE';

const initState = {
    user: null
};

export default function buyXXL(state = initState, action) {
    if (action.type === GET_BUYXXL_PROFILE_SUCCESS) {
        let {status, user, ...rest} = action.result;

        return {
            ...state,
            ...rest,
            user: new BobTVUser(user)
        }
    }

    return state;
}

export function getProfile({id}) {
    return {
        types: [GET_BUYXXL_PROFILE_REQUEST, GET_BUYXXL_PROFILE_SUCCESS, GET_BUYXXL_PROFILE_FAILURE],
        promise: backend.getProfile({id})
    }
}



// WEBPACK FOOTER //
// ./src/reducers/buyXXL.js